import { Component, ElementRef, ViewChild } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, FormControl, NgModel } from '@angular/forms';
import axios from 'axios';
import { NgxSpinnerService } from 'ngx-spinner';
import { BrdsqlService } from '../../services/brdsql.service';
import { Authenticationservice } from '../../services/authentication.service';


@Component({
  selector: 'app-okay-get-fert3',
  templateUrl: './okay-get-fert3.component.html',
  styleUrls: ['./okay-get-fert3.component.css']
})
export class OkayGetFert3Component {
  @ViewChild('tb_fmgetFactor') tb_fmgetFactor!: ElementRef;
  Actioncmg: UntypedFormGroup;
  list_itid = [];
  userdata: any;
  constructor(private auth: Authenticationservice, private spinner: NgxSpinnerService, private fb: UntypedFormBuilder, private brdsql: BrdsqlService) {
    this.userdata = this.auth.Authention();
    this.Actioncmg = this.fb.group({
      selecyear: '',
      selectzone: '',
      comment: '',
      fmcode: '',
      term: '',
      title_id: '',
    })
  }
  ngOnInit(): void {
    this.LoadAllcp(0);
    //this.LoadZone();
    this.fmgetFactor();
    this.Loadfert3();
    //this.Loadmain_topic();
    this.zonecode = this.brdsql.supzone
  }

  zonecode = [];
  SubTraindata = [];
  Alldata_cp = [];

  /*LoadZone() {
    let url = "https://asia-southeast2-brr-farmluck.cloudfunctions.net/brdsqlapi/zoneGroup";
    axios.get(url).then(res => {
      this.zonecode = (res.data.recordset);
    }).catch(err => { throw (err) })
  }*/


  fmgetFactorNow = [];
  fmgetFactor() {
    this.spinner.show();
    let url = "https://asia-southeast2-brr-farmluck.cloudfunctions.net/dbcps/select_s_f_w_0?s=*&f=[CPS6263].[dbo].[v_getfactor6667]&w=[getFert3]='Y'" + " order by datepost desc ";
    axios.get(url).then(res => {
      if (res.data.length > 0) {
        this.fmgetFactorNow = res.data.sort((a, b) => {
          return new Date(b.datepost).getTime() - new Date(a.datepost).getTime();
        });
        setTimeout(() => {
          $(this.tb_fmgetFactor.nativeElement).DataTable();
        }, 10);
      }
      else this.fmgetFactorNow = [];
    }).catch(err => { console.log(err); })
    this.spinner.hide();
  };


  list_g3s = [];//รายการที่อนุมัติแล้ว
  LoadAllcp(typeC = 0) {
    this.spinner.show();
    let fm1 = '', url: string;
    // if(typeC!=0){ fm1=`and [FMCODE_B1]='`+itid+`'` }

    url = `https://asia-southeast2-brr-farmluck.cloudfunctions.net/dbcps/select_s_f_w_0?s=[itid],[year],[intlandno],[fmcode],[fmname],[supzone],[supcode],[landvalue],[canetype],[ton],[PlantDate],[getFert3]&f=[CPS6263].[dbo].[v_cp6667_basic]&w=(left(fmcode,3))<>'900'`;
    axios.get(url).then(res => {
      if (res.data.length >= 1) {
        this.spinner.hide();
        //console.log('data[0]',res.data.length,' ; ',typeC);
        this.Alldata_cp = (res.data);
        //this.list_g3s = this.Alldata_cp.filter((el) => el.getFert3 == 'Y');
        if (typeC != 0) {
          if (this.Alldata_cp.length > 0) {
            //this.Alldata_cp = this.Alldata_cp.filter((el) => el.itid != itid );            
            //this.Alldata_cp.push(res.data[0])
            //console.log('data[0]',res.data[0]);            
            setTimeout(() => {
              this.sv_data();
            }, 100);
          }
        }
      }
      else {
        alert("ไม่สามารถโหลดข้อมูลแปลงได้");
      }
      console.log('Alldata_cp', this.Alldata_cp.length, ' ; ', typeC);
    }).catch(err => { throw (err) })
  }

  datafert3 = [];
  Loadfert3() {
    this.spinner.show();
    let url: string;
    url = `https://asia-southeast2-brr-farmluck.cloudfunctions.net/dbcps/select_s_f_w_0?s=[itid],sum(amt1)[getFert3]&f=[CPS6263].[dbo].[v_getfactor6667]&w=[getFert3]='Y'group by[itid]`;
    axios.get(url).then(res => {
      this.spinner.hide();
      let data = res.data
      if (data.length >= 1) {
        console.log('data : ', data);
        this.datafert3 = (data);
      }
    }).catch(err => { throw (err) })
  }

  dataResult = [];
  sv_data() {//กรองข้อความ
    let txa = this.Actioncmg.value;
    let zone = txa.selectzone, txt = txa.term.trim();
    let keyword = (txt).toLowerCase();
    if (keyword.length > 0) {
      if (zone == '') { this.dataResult = this.Alldata_cp.filter((el) => (el.intlandno.toLowerCase().indexOf(keyword) > -1 || el.fmname.toLowerCase().indexOf(keyword) > -1)); }
      else { this.dataResult = this.Alldata_cp.filter((el) => el.supzone == zone && (el.intlandno.toLowerCase().indexOf(keyword) > -1 || el.fmname.toLowerCase().indexOf(keyword) > -1)); }
    }
    //console.log('txa:',txa,'zone:',zone,'keyword;',keyword);
  }

  dataAr = [];
  getdata(data) {

    let data_l = data;
    this.dataAr = this.dataAr.filter(el => el.itid != data_l.itid);
    /*
    this.dataAr = this.dataAr.filter((v,i,a)=>a.findIndex(t=>(t.FMCODE === v.FMCODE))===i);
    let datain = {'FMCODE': FMCODE ,'fmname':fmname,'tid':tid};   
    */
    this.dataAr.push(data_l);
    //console.log('dataAr', this.dataAr);
    this.count_list();

  }
  remove_val(itid = '') {
    this.dataAr = this.dataAr.filter(el => el.itid != itid);
    this.count_list();
  }

  len_list = [0, 0];
  count_list() {
    let data = this.dataAr;
    const count1 = data.reduce((acc, obj) => {
      if (obj.getFert3 == 'N') acc++;
      return acc;
    }, 0);

    const count2 = data.reduce((acc, obj) => {
      if (obj.getFert3 == 'Y') acc++;
      return acc;
    }, 0);

    //console.log(count1, count2);
    this.len_list = [count1, count2];
  }


  save_getFert3(get3 = '') {
    let dAR = this.dataAr;
    let data_list1 = dAR.filter(el => el.getFert3 == 'Y').map(function (elem) { return "'" + elem.itid + "'" });//filterรายการที่อนุมัติ
    let data_list2 = dAR.filter(el => el.getFert3 == 'N').map(function (elem) { return "'" + elem.itid + "'" });//filterรายการที่ยังอนุมัติ
    let data_list, txt = '';

    if (get3 == 'N') {
      data_list = data_list1
      txt = 'ยกเลิกการอนุมัติ'
    }
    else if (get3 == 'Y') {
      data_list = data_list2
      txt = 'อนุมัติ'
    }

    //let supzone = data.map(function (elem){return elem.supname});   
    //data_list = this.dataAr.map(function (elem) { return "'" + elem.itid + "'" })
    let value = get3
    let l_list = data_list.join(" , ")
    //console.log('l_list:',l_list);

    if (data_list.length > 0) {
      if (confirm('ต้องการ ' + txt + ' ' + data_list.length + ' แปลง ใช่หรือไม่?')) {
        let url = `https://asia-southeast2-brr-farmluck.cloudfunctions.net/dbcps/update_t_s_w?t=[dbIntech].[dbo].[areas]&s=[getFert3]='` + value + `'&w=year='2324'and[itid]in(` + l_list + `)`;
        this.spinner.show();
        //console.log('url:', url);
        axios.get(url).then(res => {
          let data = res.data;
          if (data.rowsAffected[0] > 0) {
            this.spinner.hide();
            alert(data.rowsAffected[0] + " แปลง " + txt + "ข้อมูลสำเร็จ");
            this.LoadAllcp(1);
            if (get3 == 'N') {
              this.dataAr = dAR.filter(el => el.getFert3 != 'N')
            }
            else if (get3 == 'Y') {
              this.dataAr = dAR.filter(el => el.getFert3 != 'Y')
            }
            //this.dataAr = [];
          }
          else { alert("ไม่สามารถบันทึกได้"); }
        }).catch(err => { throw (err) })
      }
    }//else alert("โปรดเลือกชาวไร่");

  }

  THtoLocalstr(date: string) {
    if (!date) return '';
    const date1 = new Date(date);
    let options: any = {
      year: "numeric", month: "short", day: "2-digit", hour: "2-digit", minute: "2-digit", timeZone: 'UTC'
    };
    return date1.toLocaleString('th-TH', options);
  }

}
